import { render, staticRenderFns } from "./paso8.vue?vue&type=template&id=264a519d&scoped=true&"
import script from "./paso8.vue?vue&type=script&lang=ts&"
export * from "./paso8.vue?vue&type=script&lang=ts&"
import style0 from "./paso8.vue?vue&type=style&index=0&id=264a519d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a519d",
  null
  
)

export default component.exports